module.exports = __webpack_public_path__ + "img/banner_helper_2.ae2e0c37.png";